import api from "./axios";
import type { Entry } from "@/types";

interface EntryFilters {
  categoryId?: string;
  subcategoryId?: string;
  from?: string;
  to?: string;
}

export const getEntries = (filters?: EntryFilters) =>
  api.get<Entry[]>("/entries", { params: filters }).then((r) => r.data);

export const getEntry = (id: string) =>
  api.get<Entry>(`/entries/${id}`).then((r) => r.data);

export const createEntry = (data: {
  name?: string | null;
  description?: string;
  categoryId: string;
  subcategoryId?: string | null;
  amount: number;
  currency?: string;
  spentAt?: string;
}) => api.post<Entry>("/entries", data).then((r) => r.data);

export const updateEntry = (
  id: string,
  data: {
    name?: string | null;
    description?: string;
    categoryId?: string;
    subcategoryId?: string | null;
    amount?: number;
    currency?: string;
    spentAt?: string;
  },
) => api.patch<Entry>(`/entries/${id}`, data).then((r) => r.data);

export const deleteEntry = (id: string) =>
  api.delete(`/entries/${id}`).then((r) => r.data);
